import { currentServerUnixTime } from 'utils';
import { getAPIErrorMessage } from 'api';
import * as debounce from 'debounce';
import * as deep_extend from 'deep-extend';
import { can_write_individual_name } from 'console/account/account_tsx';
import * as lodash from 'lodash';
export const deviceAdded = (device) => ({ type: 'DEVICE_ADDED', device });
export const deviceDeleted = (device_id) => ({ type: 'DEVICE_DELETED', device_id });
export const setDeviceOnline = (device_id, online) => (dispatch, getState) => dispatch({
    type: 'SET_DEVICE_ONLINE',
    device_id,
    online,
    time: currentServerUnixTime(getState().server_time),
});
export const applyTemperatureUpdate = (device_id, time, temperature) => ({
    type: 'APPLY_TEMPERATURE_UPDATE',
    device_id,
    time,
    temperature,
});
export const applyNewRFStatuses = (device_id, rf) => ({
    type: 'APPLY_NEW_RF_STATUSES',
    device_id,
    rf,
});
export const customCommandSuccess = (device_id, command_id) => ({
    type: 'SEND_CUSTOM_COMMAND__SUCCESS',
    device_id,
    command_id,
});
export const applyFiletransferUpdate = (device_id, transfer) => ({
    type: 'APPLY_FILETRANSFER_UPDATE',
    device_id,
    transfer,
});
export const applyResetThermometersResponse = (device_id) => async (dispatch, getState, { api }) => {
    dispatch({
        type: 'RESET_THERMOMETERS_RESPONSE',
        device_id,
    });
    try {
        const { thermometers } = await api.load_thermometers(device_id);
        dispatch({
            type: 'LOAD_THERMOMETERS__OK',
            device_id,
            thermometers,
        });
    }
    catch (error) {
        console.error('Не смог загрузить данные по термостатам', error);
    }
};
const filter_response_for_ui_settings = (rest, is_owner, user_id) => {
    if ('ui_settings' in rest) {
        let new_rest = {};
        for (const key in rest.ui_settings) {
            if (is_owner) {
                if (key.match(/access/)) {
                    new_rest = lodash.omit(rest.ui_settings, key);
                }
                else {
                    new_rest = rest.ui_settings;
                }
            }
            else {
                const dynamicRegex = new RegExp('_access_' + user_id);
                if (key.match(dynamicRegex)) {
                    const new_key = key.replace(dynamicRegex, '');
                    new_rest = {
                        ...new_rest,
                        [new_key]: rest.ui_settings[key],
                    };
                }
                else if (key === 'icons' || key === 'hidden_name') {
                    new_rest = { ...new_rest, [key]: rest.ui_settings[key] };
                }
            }
        }
        return { ...rest, ui_settings: new_rest };
    }
    else {
        return rest;
    }
};
//thermostat_ext_modes_config
export const requestDeviceUpdate = (device_id, setter, { ignore_server_response = false, obey_only_last_response = false } = {}, object_id) => async (dispatch, getState, { api }) => {
    if (obey_only_last_response) {
        const request_code = Date.now();
        setter = {
            ...setter,
            //@ts-ignore
            request_code,
        };
        dispatch({
            type: 'OBEY_ONLY_LAST_RESPONSE',
            device_id,
            fields: Object.keys(setter),
            request_code,
        });
    }
    // @ts-ignore     PRELOAD из CP
    const user_id = getState().account?.id || window.PRELOAD.admin.user_id;
    const is_owner = getState().devices.items.find((device) => device.id == device_id)
        ?.user_id === user_id;
    const is_user_pro = can_write_individual_name(getState());
    try {
        const response = await api.update_device(device_id, setter);
        dispatch({
            type: 'APPLY_DEVICE_UPDATE',
            device_id,
            setter: filter_response_for_ui_settings(setter, is_owner, user_id),
            request_code: null,
            user_id,
            is_user_pro,
        });
        const { _request_time, _request_code, ok, ...rest } = response;
        if (!ignore_server_response) {
            dispatch({
                type: 'APPLY_DEVICE_UPDATE',
                device_id,
                setter: filter_response_for_ui_settings(rest, is_owner, user_id),
                request_code: null,
                user_id,
                is_user_pro,
            });
        }
    }
    catch (e) {
        console.error(e);
        const error_message = getAPIErrorMessage(e, 'Произошла ошибка');
        if (typeof object_id === 'number') {
            dispatch({
                type: 'SET_THERMOSTAT_MODES_ACTION__FAIL',
                device_id,
                object_id,
                error_message,
            });
            setTimeout(() => dispatch({
                type: 'RESET_THERMOSTAT_MODES_ACTION__FAIL',
                device_id,
                object_id,
            }), 0);
        }
    }
};
export const applyDeviceUpdate = (device_id, setter, request_code = null) => async (dispatch, getState) => {
    const user_id = getState().account.id;
    const is_owner = getState().devices.items.find((device) => device.id == device_id)
        ?.user_id === user_id;
    const is_user_pro = can_write_individual_name(getState());
    return dispatch({
        type: 'APPLY_DEVICE_UPDATE',
        device_id,
        setter: filter_response_for_ui_settings(setter, is_owner, user_id),
        request_code,
        user_id,
        is_user_pro,
    });
};
export const formatFilesystem = (device_id) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'FORMAT_FILESYSTEM__REQUEST', device_id });
    try {
        const response = await api.format_file_system(device_id);
        for (const transfer of response.transfers) {
            dispatch(applyFiletransferUpdate(device_id, transfer));
        }
        dispatch({ type: 'FORMAT_FILESYSTEM__OK', device_id });
    }
    catch ({ json }) {
        dispatch({ type: 'FORMAT_FILESYSTEM__FAIL', device_id, error: json });
    }
    setTimeout(() => dispatch({ type: 'FORMAT_FILESYSTEM__CLEAR', device_id }), 5e3);
};
export const reloadDeviceRF = (device_id) => (dispatch, getState, { device_manager }) => {
    const old_dev = device_manager?.device(device_id);
    if (old_dev == null) {
        return;
    }
    dispatch({ type: 'START_RF_RELOAD', device_id });
    // @ts-ignore
    old_dev.rf_load_devices(({ ok, rf }) => dispatch({
        type: 'FINISH_RF_RELOAD',
        device_id,
        ok,
        rf,
    }));
};
export const deviceRequestGuard = (device_id, guard) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'DEVICE_GUARD__REQUEST', device_id });
    try {
        await api.requestDeviceIO(device_id, 'guard-state', 'string', guard ? 'enabled' : 'disabled');
    }
    catch (e) {
        const error_message = getAPIErrorMessage(e, 'Произошла ошибка');
        dispatch({ type: 'DEVICE_GUARD__FAIL', device_id, error_message });
        setTimeout(() => dispatch({ type: 'DEVICE_GUARD__RESET', device_id }), 0);
    }
};
export const deviceRequestEngineBlock = (device_id, value) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'DEVICE_ENGINE_BLOCK__REQUEST', device_id });
    try {
        await api.requestDeviceIO(device_id, 'engine-block', 'bool', value);
    }
    catch (e) {
        const error_message = getAPIErrorMessage(e, 'Произошла ошибка');
        dispatch({ type: 'DEVICE_ENGINE_BLOCK__FAIL', device_id, error_message });
        setTimeout(() => dispatch({ type: 'DEVICE_ENGINE_BLOCK__RESET', device_id }), 0);
    }
};
export const deviceRequestSiren = (device_id, value) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'DEVICE_SIREN__REQUEST', device_id });
    try {
        await api.requestDeviceIO(device_id, 'siren', 'bool', value);
    }
    catch (e) {
        const error_message = getAPIErrorMessage(e, 'Произошла ошибка');
        dispatch({ type: 'DEVICE_SIREN__FAIL', device_id, error_message });
        setTimeout(() => dispatch({ type: 'DEVICE_SIREN__RESET', device_id, error_message }), 0);
    }
};
export const deviceRequestWebasto = (device_id, value) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'DEVICE_WEBASTO__REQUEST', device_id });
    try {
        await api.requestDeviceIO(device_id, 'webasto', 'bool', value);
    }
    catch (e) {
        const error_message = getAPIErrorMessage(e, 'Произошла ошибка');
        dispatch({ type: 'DEVICE_WEBASTO__FAIL', device_id, error_message });
        setTimeout(() => dispatch({ type: 'DEVICE_WEBASTO__RESET', device_id }), 0);
    }
};
export const deviceRequestAutoStart = (device_id, autostart_command) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'DEVICE_AUTOSTART__REQUEST', device_id });
    try {
        await api.requestDeviceIO(device_id, 'auto-ignition', 'auto-ignition', autostart_command);
    }
    catch (e) {
        const error_message = getAPIErrorMessage(e, 'Произошла ошибка');
        dispatch({ type: 'DEVICE_AUTOSTART__FAIL', device_id, error_message });
        setTimeout(() => dispatch({ type: 'DEVICE_AUTOSTART__RESET', device_id }), 0);
    }
};
export const sendCustomCommand = (device_id, element_no, command_id) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'SEND_CUSTOM_COMMAND__REQUEST', device_id, element_no });
    try {
        await api.sendCustomCommand(device_id, command_id);
    }
    catch (error) {
        const error_message = getAPIErrorMessage(error, 'Произошла ошибка');
        dispatch({
            type: 'SEND_CUSTOM_COMMAND__FAIL',
            device_id,
            element_no,
            error_message,
        });
        setTimeout(() => dispatch({
            type: 'SEND_CUSTOM_COMMAND__RESET',
            device_id,
            element_no,
        }), 0);
    }
};
export const setServiceModeManual = (device_id) => (dispatch) => {
    dispatch({ type: 'SET_SERVICE_MODE__MANUAL', device_id });
};
export const formatZTC700 = (device_id) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'FORMAT_ZTC700__REQUEST', device_id });
    try {
        const response = await api.format_ztc_700(device_id);
        for (const transfer of response.transfers) {
            dispatch(applyFiletransferUpdate(device_id, transfer));
        }
        dispatch({ type: 'FORMAT_ZTC700__OK', device_id });
    }
    catch ({ json }) {
        dispatch({ type: 'FORMAT_ZTC700__FAIL', device_id, error: json });
    }
    finally {
        setTimeout(() => dispatch({ type: 'FORMAT_ZTC700__CLEAR', device_id }), 5e3);
    }
};
export const fixHW205AMR = (device_id) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'FIX_HW205_AMR__REQUEST', device_id });
    try {
        const response = await api.fix_hw_205_amr(device_id);
        for (const transfer of response.transfers) {
            dispatch(applyFiletransferUpdate(device_id, transfer));
        }
        dispatch({ type: 'FIX_HW205_AMR__OK', device_id });
    }
    catch ({ json }) {
        dispatch({ type: 'FIX_HW205_AMR__FAIL', device_id, error: json });
    }
    finally {
        setTimeout(() => dispatch({ type: 'FIX_HW205_AMR__CLEAR', device_id }), 5e3);
    }
};
export const downloadL1000Log = (device_id) => async (dispatch, getState, { api, comet }) => {
    dispatch({ type: 'DOWNLOAD_L1000_LOG__REQUEST', device_id });
    try {
        const response = await api.downloadL1000Log(device_id);
        dispatch({ type: 'DOWNLOAD_L1000_LOG__OK', device_id });
        comet.listen({
            once: true,
            event: 'filetransfer_update',
            condition: {
                device_id,
                transfer: {
                    id: response.transfer.id,
                    done: true,
                },
            },
            callback(msg) {
                dispatch({ type: 'DOWNLOAD_L1000_LOG__OK', device_id });
                return ((window.location = api.get_url('get_downloaded_file', {
                    device_id,
                    content_id: msg.transfer.content_ids?.['log.txt'] ?? '',
                }, false)),
                    true);
            },
        });
    }
    catch ({ json }) {
        dispatch({ type: 'DOWNLOAD_L1000_LOG__FAIL', device_id, error: json });
    }
    finally {
        setTimeout(() => dispatch({ type: 'DOWNLOAD_L1000_LOG__CLEAR', device_id }), 5e3);
    }
};
export const forceUpdateState = () => ({ type: 'FORCE_UPDATE_STATE' });
export const applyDevicesJson = (devices_json) => ({
    type: 'APPLY_DEVICES_JSON',
    devices_json,
});
//  thermostat_target_temps
const create_debounced_settings_sender = (debounce_time, obey_only_last_response) => {
    let setters = {};
    const debounced_send = debounce.debounce(async (dispatch, api) => {
        for (const device_id of Object.keys(setters || {})) {
            let data;
            const setter = setters[device_id];
            const _device_id = ~~device_id;
            if (obey_only_last_response) {
                const request_code = Date.now();
                dispatch({
                    type: 'OBEY_ONLY_LAST_RESPONSE',
                    device_id: _device_id,
                    fields: Object.keys(setter),
                    request_code,
                });
                //@ts-ignore
                data = { ...setter, request_code };
            }
            else {
                data = { ...setter };
            }
        }
        setters = {};
    }, debounce_time);
    return async (dispatch, getState, api, device_id, setter, object_id) => {
        const user_id = getState().account.id;
        const is_user_pro = can_write_individual_name(getState());
        try {
            await api.update_device(device_id, setter);
            dispatch({
                type: 'APPLY_DEVICE_UPDATE',
                device_id,
                setter,
                request_code: null,
                user_id,
                is_user_pro,
            });
        }
        catch (error) {
            const error_message = getAPIErrorMessage(error, 'Произошла ошибка');
            if (typeof object_id === 'number') {
                dispatch({
                    type: 'SET_THERMOSTAT_TEMPS_ACTION__FAIL',
                    device_id,
                    object_id,
                    error_message,
                });
                setTimeout(() => dispatch({
                    type: 'RESET_THERMOSTAT_TEMPS_ACTION__FAIL',
                    device_id,
                    object_id,
                }), 0);
            }
        }
        deep_extend(setters, { [device_id]: setter });
        debounced_send(dispatch, api);
    };
};
const thermostat_zone_temps_sender = create_debounced_settings_sender(1e3, true);
export const requestThermostatZoneTemps = (device_id, target_temps, object_id) => (dispatch, getState, { api }) => thermostat_zone_temps_sender(dispatch, getState, api, device_id, {
    thermostat_target_temps: target_temps,
}, object_id);
export const cancelFiletransfers = (device_id, options) => async (dispatch, getState, { api }) => {
    const { transfers } = await api.cancel_filetransfers(device_id, options);
    for (const transfer of transfers)
        dispatch(applyFiletransferUpdate(device_id, transfer));
};
export const applyDeclineUpdateFirmwareVersion = (device_id, decline_version) => ({
    type: 'APPLY_DECLINE_UPDATE_FIRMWARE_VERSION',
    device_id,
    decline_version,
});
